import Montserrat400 from 'src/domains/layouts/shared/assets/fonts/montserrat-regular.woff2';
import Montserrat500 from 'src/domains/layouts/shared/assets/fonts/montserrat-medium.woff2';
import Montserrat700 from 'src/domains/layouts/shared/assets/fonts/montserrat-bold.woff2';

import GentonaRegular400 from 'src/domains/layouts/shared/assets/fonts/gentona_light.woff2';
import GentonaMedium600 from 'src/domains/layouts/shared/assets/fonts/gentona_semi_bold.woff2';
import GentonaBold700 from 'src/domains/layouts/shared/assets/fonts/gentona_book_bold.woff2';

import OpenSans400 from 'src/domains/layouts/shared/assets/fonts/opensans-regular.woff2';
import OpenSans600 from 'src/domains/layouts/shared/assets/fonts/opensans-semibold.woff2';
import OpenSans700 from 'src/domains/layouts/shared/assets/fonts/opensans-bold.woff2';

import MavenPro400 from 'src/domains/layouts/shared/assets/fonts/MavenProRegular.woff2';
import MavenPro500 from 'src/domains/layouts/shared/assets/fonts/MavenProMedium.woff2';
import MavenPro600 from 'src/domains/layouts/shared/assets/fonts/MavenProBold.woff2';
import MavenPro700 from 'src/domains/layouts/shared/assets/fonts/MavenProBlack.woff2';

import SatoshiRegular400 from 'src/domains/layouts/shared/assets/fonts/Satoshi-Regular.woff2';
import SatoshiMedium500 from 'src/domains/layouts/shared/assets/fonts/Satoshi-Medium.woff2';
import SatoshiBold700 from 'src/domains/layouts/shared/assets/fonts/Satoshi-Bold.woff2';

interface FontOptionsType {
    name: string;
    format: 'woff' | 'woff2';
    fonts: Array<{
        weight: number;
        path: string;
    }>;
}

const fontsDefault: Array<FontOptionsType> = [
    {
        name: 'Montserrat',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: Montserrat400,
            },
            {
                weight: 500, // Medium
                path: Montserrat500,
            },
            {
                weight: 700, // Bold
                path: Montserrat700,
            },
        ],
    },
    {
        name: 'Gentona',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: GentonaRegular400,
            },
            {
                weight: 600, // Medium
                path: GentonaMedium600,
            },
            {
                weight: 700, // Bold
                path: GentonaBold700,
            },
        ],
    },
    {
        name: 'Open Sans',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: OpenSans400,
            },
            {
                weight: 600, // Semi bold
                path: OpenSans600,
            },
            {
                weight: 700, // Bold
                path: OpenSans700,
            },
        ],
    },
    {
        name: 'Maven Pro',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: MavenPro400,
            },
            {
                weight: 500, // Medium
                path: MavenPro500,
            },
            {
                weight: 600, // Bold
                path: MavenPro600,
            },
            {
                weight: 700, // Black
                path: MavenPro700,
            },
        ],
    },
    {
        name: 'Satoshi',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: SatoshiRegular400,
            },
            {
                weight: 500, // Medium
                path: SatoshiMedium500,
            },
            {
                weight: 700, // Bold
                path: SatoshiBold700,
            },
        ],
    },
];

const generateFontFace = (optionsList: Array<FontOptionsType>): string => {
    const optionsListResult: Array<string> = [];

    for (const options of optionsList) {
        const { name, fonts, format } = options;

        for (const font of fonts) {
            optionsListResult.push(`
                @font-face {
                    font-family: '${name}';
                    font-weight: ${font.weight};
                    font-style: normal;
                    src: url('${font.path}') format('${format}');
                    font-display: swap;
                }
            `);
        }
    }

    return optionsListResult.join('');
};

export const getUniverseFont = (): string => {
    return generateFontFace(fontsDefault);
};
